<template>
  <div class="boxContent vif-container">
    <div>
      <div class="vif-header">
        <h1 class="title">Diesel Information Form</h1>
        <p>
          Please provide us with accurate information; we use this to customize
          your new unit to your diesel. If you provide us inaccurate
          information, your unit will not function properly, and you may be
          subject to a $100 reprogram charge. Questions call 888-875-2958.
        </p>
      </div>
      <div>
        <div class="infos_block col">
          <div v-if="this.vehicle != ''">
            <p class="form-error" v-if="!formData.vin">
              We still need your diesel VIN.
            </p>
            <p class="form-error" v-if="!formData.snumber">
              We still need your Engine Serial Number.
            </p>
            <p class="form-error" v-if="!formData.transmission">
              We still need the type of Transmission for your diesel.
            </p>
            <p class="form-error" v-if="!formData.drive">
              We still need the Wheel Drive for your diesel.
            </p>
            <p class="form-error" v-if="!formData.size">
              We still need your diesel Engine Size.
            </p>
            <p class="form-error" v-if="!formData.number">
              We still need your Part Number from the Computer you are replacing
              in your diesel.
            </p>
          </div>
          <div id="infoCol">
            <div class="form-row">
              <div class="form">
                <span class="vifTxtMain">*Name:</span>
                <input
                  name="Name"
                  type="text"
                  class="textbox"
                  :class="invalidFields.Name ? 'error' : ''"
                  id="Name"
                  v-model="formData.name"
                  @blur="validateFieldOnFocus"
                />
                <span class="help-block form-error" v-if="invalidFields.Name"
                  >Name is a required field.</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Email:</span>
                <input
                  name="email"
                  type="text"
                  class="textbox validate"
                  :class="invalidFields.email ? 'error' : ''"
                  id="email"
                  v-model="formData.email"
                  @blur="validateFieldOnFocus"
                />
                <span class="help-block form-error" v-if="invalidFields.email"
                  >Email Address is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Type of Unit Ordered:</span>
                <select
                  name="unit"
                  id="unit"
                  class="selectbox validate"
                  :class="invalidFields.unit ? 'error' : ''"
                  v-model="formData.unit"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="unit.id"
                    v-for="(unit, id) in this.units"
                    v-bind:key="id"
                  >
                    {{ unit.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.unit"
                  >Type of Unit Ordered is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Make:</span>
                <select
                  name="make"
                  id="make"
                  class="selectbox validate"
                  :class="invalidFields.make ? 'error' : ''"
                  v-model="formData.make"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="make.id"
                    v-for="(make, id) in makes"
                    v-bind:key="id"
                  >
                    {{ make.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.make"
                  >Make is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Model:</span>
                <select
                  name="model"
                  id="model"
                  class="selectbox validate"
                  :class="invalidFields.model ? 'error' : ''"
                  v-model="formData.model"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="model.id"
                    v-for="(model, id) in models"
                    v-bind:key="id"
                  >
                    {{ model.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.model"
                  >Model is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Year:</span>
                <select
                  name="year"
                  id="year"
                  class="selectbox validate"
                  :class="invalidFields.year ? 'error' : ''"
                  v-model="formData.year"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="year.id"
                    v-for="(year, id) in this.years"
                    v-bind:key="id"
                  >
                    {{ year.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.year"
                  >Year is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">VIN</span>
                <input
                  name="vin"
                  type="text"
                  class="textbox"
                  id="vin"
                  v-model="formData.vin"
                />
              </div>
              <div class="form">
                <span class="vifTxtMain">Engine Serial Number</span>
                <input
                  name="Snumber"
                  type="text"
                  class="textbox"
                  id="Snumber"
                  v-model="formData.snumber"
                />
              </div>
              <div class="form">
                <span class="vifTxtMain">Transmission:</span>
                <select
                  name="transmission"
                  id="transmission"
                  class="selectbox validate"
                  v-model="formData.transmission"
                >
                  <option value="">Please select</option>
                  <option
                    :value="transmission.id"
                    v-for="(transmission, id) in this.transmissions"
                    v-bind:key="id"
                  >
                    {{ transmission.name }}
                  </option>
                </select>
              </div>
              <div class="form">
                <span class="vifTxtMain">Wheel Drive:</span>
                <select
                  name="drive"
                  id="drive"
                  class="selectbox validate"
                  v-model="formData.drive"
                >
                  <option value="">Please select</option>
                  <option
                    :value="drive.id"
                    v-for="(drive, id) in this.drives"
                    v-bind:key="id"
                  >
                    {{ drive.name }}
                  </option>
                </select>
              </div>
              <div class="form">
                <span class="vifTxtMain">Engine Size</span>
                <input
                  name="size"
                  type="text"
                  class="textbox"
                  id="size"
                  v-model="formData.size"
                />
              </div>
              <div class="form">
                <span class="vifTxtMain">Part Number from Computer You are Replacing in Your Truck <a href="/partnumber" target="_blank">Where is correct part #?</a></span>
                <input
                  name="number"
                  type="text"
                  class="textbox"
                  id="number"
                  v-model="formData.number"
                />
              </div>
            </div>
          </div>
          <div class="place_btn">
            <a
              href="#"
              class="save"
              title="Save"
              @click="validAllFields($event)"
              >Save</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vehicle_id: {
      type: String,
    },
    order_id: {
      type: String
    },
  },
  created() {
    axios.get('/api/diesel/makes').then((res) => {
      this.makes = res.data
    })
    this.vehicle = this.vehicle_id
    console.log(this.vehicle_id)
    if (this.vehicle_id != '') {
      axios.get('/api/diesel/' + this.vehicle_id).then((res) => {
        this.formData.name = res.data.name
        this.formData.email = res.data.email
        this.formData.make = res.data.make_id
        this.formData.model = res.data.model_id
        this.formData.vin = res.data.vin
        this.formData.snumber = res.data.snumber
        this.formData.size = res.data.engine_size
        this.formData.number = res.data.part_number

        this.formData.unit = this.units.filter(
          (mk) => mk.name == res.data.unit_type
        )[0].id
        this.formData.transmission = res.data.transmission
          ? this.transmissions.filter(
              (mk) => mk.name == res.data.transmission
            )[0].id
          : ''
        this.formData.drive = res.data.wheel_drive
          ? this.drives.filter((mk) => mk.name == res.data.wheel_drive)[0].id
          : ''
        this.formData.year = res.data.year
      })
    }
  },
  computed: {
    formMake() {
      return this.formData.make
    },
    formModel() {
      return this.formData.model
    },
  },
  watch: {
    formMake: function (val) {
      this.years = null
      if (val) {
        axios.get('/api/diesel/model/' + val).then((res) => {
          this.models = res.data
        })
      }
    },
    formModel: function (val) {
      if (val) {
        axios.get('/api/diesel/model-year/' + val).then((res) => {
          this.years = res.data
        })
      }
    },
  },
  data() {
    return {
      makes: null,
      models: null,
      years: null,
      yearValue: '',
      invalidFields: {},
      vehicle: '',
      formData: {
        name: '',
        email: '',
        unit: '',
        make: '',
        model: '',
        year: '',
        vin: '',
        snumber: '',
        transmission: '',
        drive: '',
        size: '',
        number: '',
      },
      units: [
        { id: 1, name: 'ECM' },
        { id: 2, name: 'PCM' },
        { id: 3, name: 'TCM' },
        { id: 4, name: 'FICM' },
      ],
      transmissions: [
        { id: 1, name: 'manual' },
        { id: 2, name: 'automatic' },
      ],
      drives: [
        { id: 1, name: '2WD two wheel drive' },
        { id: 2, name: '4WD four wheel drive' },
        { id: 3, name: 'AWD all wheel drive' },
      ],
      notRequiredInputs: [
        'vin',
        'snumber',
        'transmission',
        'drive',
        'size',
        'number',
      ],
    }
  },
  methods: {
    async validAllFields(e, data = null, masterKey = null) {
      e.preventDefault()

      if (!data) {
        data = this.formData
      }

      let notRequired = this.notRequiredInputs

      for (let key in data) {
        let needCheck = true
        notRequired.forEach((field) => {
          let fieldArr = field.split('|')
          let valueForField = ''
          let nextField = ''
          if (fieldArr.length > 1) {
            valueForField = fieldArr[1].split(':')[1]
            nextField = fieldArr[1].split(':')[0]
          }

          if (fieldArr.length === 1 && key == fieldArr[0]) {
            needCheck = false
          }

          // if this item contains next field and it's false we need to ignore field
          if (
            fieldArr.length === 2 &&
            key == fieldArr[0] &&
            !this.formData[nextField]
          ) {
            needCheck = false
          }

          if (
            valueForField &&
            key == fieldArr[0] &&
            this.formData[nextField] !== valueForField
          ) {
            needCheck = false
          }
        })
        if (!needCheck) continue
        if (typeof data[key] == 'object') {
          return this.validAllFields(e, data[key], key)
        }
        if (masterKey) {
          if (!this.formData[masterKey][key]) {
            this.$set(
              this.invalidFields,
              this.mappingModelToErrors(masterKey + '.' + key),
              true
            )
          }
        } else {
          if (!this.formData[key]) {
            this.$set(this.invalidFields, this.mappingModelToErrors(key), true)
          }
        }
      }

      let canCreateOrder = true
      for (let key in this.invalidFields) {
        if (this.invalidFields[key]) {
          return false
        }
      }
      return this.vifCreate()
    },
    vifCreate() {
      let makeName = this.makes.filter((mk) => mk.id == this.formData.make)[0]
        .name
      let modelName = this.models.filter(
        (md) => md.id == this.formData.model
      )[0].name
      let yearValue = this.years.filter((yr) => yr.id == this.formData.year)[0]
        .name
      let unitValue = this.units[this.formData.unit - 1].name
      let transmissionValue = this.formData.transmission
        ? this.transmissions[this.formData.transmission - 1].name
        : ''
      let driveValue = this.formData.drive
        ? this.drives[this.formData.drive - 1].name
        : ''
      localStorage.removeItem('items')
      axios
        .post('/api/dif-mail', {
          ...this.formData,
          vehicle: this.vehicle,
          makeName,
          modelName,
          yearValue,
          unitValue,
          transmissionValue,
          driveValue,
          query_order_id: this.order_id,
        })
        .then((response) => {
          if (!response.data.done) {
            window.location.href = '/diesel_information_form/' + response.data.vehicle_id
          } else {
            window.location.href = '/vif-thankyou?check=2'
          }
        })
        .catch((responseErrors) => {
          if (responseErrors.response) {
            if (responseErrors.response.status === 301) {
              return (location.href = responseErrors.response.data.redirect)
            }
          }
        })
    },
    mappingModelToErrors(key) {
      let mapping = {
        name: 'Name',
      }
      return mapping[key] || key
    },
    validateFieldOnFocus(e) {
      let validType = 'checkEmpty'
      switch (e.target.id) {
        case 'pass':
          validType = 'checkMatches'
          break
      }
      return this[validType](e)
    },
    checkEmpty(e) {
      if (!e.target.value) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },
    checkMatches(e) {
      let neededField = e.target.getAttribute('data-match')
      if (!e.target.value || e.target.value !== this.formData[neededField]) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },
  },
}
</script>
